/** A phone, a tablet or the app: a device whose keyboard is on the screen. There a field is never focused for the person. */
export function isTouchDevice() {
  try {
    if (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0) return true;
    return !!(typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  } catch (_) { return false; }
}
